import { SERVICE_PAGES_EN } from "@/lib/servicePages.en";


export const SERVICE_PAGES = [
  {
    id: "abonament",
    slug: "abonamentno-schetovodno-obslujvane",
    num: "01",
    title: "Абонаментно счетоводно обслужване",
    seoTitle: "Абонаментно счетоводно обслужване в Пловдив | Счетоводна къща RightAccount",
    description:
      "Пълно абонаментно счетоводство за фирми в Пловдив и цялата страна — текущо отчитане, ДДС, заплати, годишно приключване и постоянни консултации. Фиксирана месечна цена от 90 €.",
    keywords: ["абонаментно счетоводство", "счетоводни услуги Пловдив", "счетоводна къща", "месечно счетоводно обслужване"],
    intro:
      "Цялостна защита на интересите на фирмата ви пред НАП, НОИ, НСИ и Търговския регистър — срещу една фиксирана месечна цена. Вие изпращате документите, ние поемаме всичко останало.",
    priceFrom: "от 90 € / месец",
    timeline: "Стартиране до 3 работни дни",
    forWhom: [
      "Активни ЕООД/ООД с текущи фактури, банкови операции и персонал",
      "Свободни професии и самоосигуряващи се лица",
      "Онлайн магазини и фирми с вътреобщностни сделки (ДДС, Интрастат, OSS)",
      "Фирми, които сменят счетоводител и искат прехвърляне без прекъсване",
    ],
    includes: [
      { h: "Текущо счетоводно отчитане", p: "Хронологично, синтетично и аналитично осчетоводяване на всички първични документи по Закона за счетоводството и приложимите стандарти." },
      { h: "ДДС и Интрастат", p: "Ежемесечни справки-декларации по ЗДДС, дневници за покупки и продажби, VIES и Интрастат декларации при вътреобщностна търговия." },
      { h: "Разчети с контрагенти", p: "Следене на вземания и задължения с клиенти и доставчици, справки за просрочия и парични потоци." },
      { h: "Заплати и осигуровки", p: "Ведомости, фишове, Декларации 1 и 6, платежни нареждания към бюджета — включени според броя на персонала." },
      { h: "Годишно приключване", p: "Годишен финансов отчет, данъчна декларация по ЗКПО, справки за НСИ и публикуване в Търговския регистър — без допълнителна такса." },
      { h: "Постоянни консултации", p: "Неограничени консултации по текущи данъчни, счетоводни и трудови въпроси по телефон, имейл или в офиса." },
    ],
    steps: [
      { h: "Безплатна консултация", p: "Разбираме дейността, обема документи и персонала ви и изготвяме фиксирана оферта до 1 работен ден." },
      { h: "Поемане на архива", p: "При смяна на счетоводител комуникираме с досегашния ви екип и прехвърляме документацията без загуба на информация." },
      { h: "Месечен ритъм", p: "Изпращате документи до 5-то число — онлайн, лично или с куриер. Подаваме всички декларации в срок и ви уведомяваме за дължимите суми." },
      { h: "Годишен отчет и планиране", p: "Приключваме годината и обсъждаме законни възможности за оптимизация на данъчната тежест за следващата." },
    ],
    faqs: [
      { q: "Как се формира месечната цена?", a: "Основно според броя първични документи и служители. Цената е фиксирана и се преразглежда само при съществена промяна в обема на дейността." },
      { q: "Мога ли да ви изпращам документите само онлайн?", a: "Да — приемаме сканирани или снимани документи по имейл или в споделена папка. Оригиналите съхранявате при вас или ги предавате периодично." },
      { q: "Работите ли с фирми извън Пловдив?", a: "Да, обслужваме клиенти от цялата страна изцяло дистанционно." },
    ],
    related: ["zaplati", "godishno", "konsultacii"],
  },
  {
    id: "godishno",
    slug: "godishno-schetovodno-priklyuchvane",
    num: "02",
    title: "Годишно счетоводно приключване",
    seoTitle: "Годишно счетоводно приключване и ГФО | RightAccount Пловдив",
    description:
      "Годишен финансов отчет, годишна данъчна декларация по ЗКПО, справки за НСИ и публикуване в Търговския регистър — еднократна услуга за фирми без текущо счетоводство или без дейност.",
    keywords: ["годишно приключване", "годишен финансов отчет", "ГФО", "публикуване в Търговския регистър", "декларация по ЗКПО"],
    intro:
      "Всички законови изисквания за администриране на фирмата след края на годината — с еднократно ангажиране на квалифициран счетоводител. Идеално за фирми без дейност или без текущ счетоводител.",
    priceFrom: "от 60 € еднократно",
    timeline: "Срок за ГДД: 1 март – 30 юни",
    forWhom: [
      "Фирми без дейност през годината, които трябва да подадат декларация за неактивност",
      "Малки фирми с ограничен брой документи, които не ползват абонамент",
      "Дружества, чиито счетоводител е прекратил дейност преди приключването",
      "Собственици, получили покана от НАП или НСИ за непубликуван отчет",
    ],
    includes: [
      { h: "Годишен финансов отчет", p: "Баланс, отчет за приходите и разходите, справка за собствения капитал и приложение — по НСС или МСФО според изискванията." },
      { h: "Годишна данъчна декларация", p: "Изготвяне и подаване на декларацията по чл. 92 от ЗКПО с всички необходими преобразувания на финансовия резултат." },
      { h: "Справки за НСИ", p: "Годишен отчет за дейността към Националния статистически институт по електронен път." },
      { h: "Публикуване в Търговския регистър", p: "Подготовка на протокол за приемане на ГФО и заявяване за обявяване в Агенцията по вписванията." },
      { h: "Декларация за неактивност", p: "За фирми без дейност — подаване на декларация по чл. 38, ал. 9 от ЗСч към Търговския регистър." },
      { h: "Проверка на предходни години", p: "Преглед за непубликувани отчети или неподадени декларации и план за изравняване." },
    ],
    steps: [
      { h: "Събиране на документи", p: "Изпращате ни фактури, банкови извлечения и договори за годината — или потвърждавате, че дейност не е имало." },
      { h: "Осчетоводяване и преобразувания", p: "Осчетоводяваме операциите, изчисляваме данъчния резултат и дължимия корпоративен данък." },
      { h: "Подаване и публикуване", p: "Подаваме ГДД и справки към НСИ по електронен път и обявяваме ГФО в Търговския регистър." },
      { h: "Архив за вас", p: "Получавате пълен електронен комплект от отчета, декларациите и входящите номера." },
    ],
    faqs: [
      { q: "Какви са сроковете за годишното приключване?", a: "ГДД по ЗКПО се подава между 1 март и 30 юни; ГФО се публикува в Търговския регистър до 30 септември. Декларацията за неактивност — до 30 юни." },
      { q: "Фирмата ми няма дейност — трябва ли да подава нещо?", a: "Да. Дори без дейност дружеството подава декларация за неактивност в Търговския регистър и годишен отчет към НСИ." },
      { q: "Какви са санкциите при пропуснат срок?", a: "От 200 до 3 000 лв. равностойност в евро за непубликуван ГФО и отделни санкции по ЗКПО за неподадена декларация. Помагаме за изравняване и минимизиране на последствията." },
    ],
    related: ["abonament", "otcheti", "konsultacii"],
  },
  {
    id: "otcheti",
    slug: "finansovi-otcheti",
    num: "03",
    title: "Съставяне на финансови отчети",
    seoTitle: "Съставяне и заверка на финансови отчети | RightAccount Пловдив",
    description:
      "Съставяне, проверка и заверяване на годишни и междинни финансови отчети от квалифициран съставител по Закона за счетоводството — за банки, инвеститори, търгове и Търговския регистър.",
    keywords: ["финансови отчети", "съставител на финансови отчети", "заверка на ГФО", "междинен отчет", "отчет за банка"],
    intro:
      "Квалифициран съставител по изискванията на Закона за счетоводството съставя и заверява или проверява и заверява финансовите отчети на вашето дружество — точно, аргументирано и в срок.",
    priceFrom: "по договаряне",
    timeline: "Обикновено 5–10 работни дни",
    forWhom: [
      "Дружества с вътрешен счетоводител, но без правоспособен съставител на отчети",
      "Фирми, кандидатстващи за кредит, лизинг или европейско финансиране",
      "Участници в обществени поръчки и търгове с изискване за заверени отчети",
      "Групи от дружества с нужда от консолидирани отчети",
    ],
    includes: [
      { h: "Годишни финансови отчети", p: "Пълен комплект по НСС или МСФО: баланс, ОПР, отчет за паричните потоци, собствен капитал и приложение." },
      { h: "Междинни отчети", p: "Тримесечни и шестмесечни отчети за банки, инвеститори, лизингодатели и програми за финансиране." },
      { h: "Проверка и заверка", p: "Преглед на съставени от друг счетоводител отчети за съответствие със закона и стандартите, с подпис на съставител." },
      { h: "Консолидирани отчети", p: "Изготвяне на консолидирани финансови отчети за групи дружества и елиминиране на вътрешногрупови операции." },
      { h: "Анализ на показателите", p: "Ликвидност, рентабилност, обращаемост и задлъжнялост — с коментар и препоръки за мениджмънта." },
      { h: "Съдействие при одит", p: "Подготовка на документация и комуникация с регистрирани одитори при задължителен или доброволен одит." },
    ],
    steps: [
      { h: "Преглед на счетоводната база", p: "Анализираме оборотната ведомост, аналитичните регистри и договорите за годината." },
      { h: "Корекции и преоценки", p: "Предлагаме коригиращи записвания — амортизации, провизии, обезценки, отсрочени данъци." },
      { h: "Съставяне на отчета", p: "Изготвяме пълния комплект със приложение и оповестявания според стандартите." },
      { h: "Заверка и предаване", p: "Подписваме като съставител и предаваме отчета в електронен и хартиен вид." },
    ],
    faqs: [
      { q: "Кой може да съставя финансови отчети по закон?", a: "Лице с висше икономическо образование и определен стаж по Закона за счетоводството или специализирано счетоводно предприятие. RightAccount отговаря на тези изисквания." },
      { q: "Може ли да заверите отчет, съставен от нашия счетоводител?", a: "Да — извършваме проверка за съответствие и при липса на съществени грешки подписваме отчета като съставител." },
      { q: "Изготвяте ли отчети по МСФО?", a: "Да, включително за дружества, които преминават от НСС към МСФО." },
    ],
    related: ["godishno", "abonament", "konsultacii"],
  },
  {
    id: "zaplati",
    slug: "trz-lichen-sastav-i-zaplati",
    num: "04",
    title: "Труд и работна заплата (ТРЗ)",
    seoTitle: "ТРЗ услуги — труд и работна заплата, личен състав | RightAccount Пловдив",
    description:
      "Пълно администриране на личния състав и заплатите: трудови договори, ведомости, Декларации 1 и 6, болнични, отпуски и кореспонденция с НАП и НОИ. Цена по-ниска от нова заплата.",
    keywords: ["ТРЗ", "труд и работна заплата", "личен състав", "обработка на заплати", "трудови договори", "Декларация 1 и 6"],
    intro:
      "Цялостно администриране на персонала ви — от първия трудов договор до последната заповед за прекратяване — срещу цена, по-ниска от назначаването на отделен ТРЗ специалист.",
    priceFrom: "от 12 € / служител месечно",
    timeline: "Ведомост до 3 дни след подаване на данните",
    forWhom: [
      "Фирми с персонал от 1 до 100+ служители без вътрешен ТРЗ отдел",
      "Работодатели с граждански договори, самоосигуряващи се управители и чуждестранни служители",
      "Компании с дистанционна работа, сумирано изчисляване и нощен труд",
      "Фирми, които искат конфиденциалност на възнагражденията извън офиса",
    ],
    includes: [
      { h: "Трудови договори и регистрация", p: "Изготвяне на договори, допълнителни споразумения и уведомления по чл. 62 от КТ към НАП в тридневния срок." },
      { h: "Ведомости и фишове", p: "Месечно изчисляване на възнаграждения, осигуровки, данък, обезщетения и удръжки; електронни фишове за служителите." },
      { h: "Декларации 1 и 6", p: "Ежемесечно подаване към НАП с данни за осигурителния доход, вноските и дължимите данъци." },
      { h: "Болнични, отпуски, майчинство", p: "Обработка на болнични листове към НОИ, изчисляване на платен отпуск и обезщетения при майчинство." },
      { h: "Досиета и длъжностни характеристики", p: "Поддържане на лични трудови досиета, заповеди, графици и длъжностни характеристики." },
      { h: "Прекратяване и обезщетения", p: "Заповеди по КТ, изчисляване на обезщетения, оформяне на трудови книжки и удостоверения УП-2 и УП-3." },
    ],
    steps: [
      { h: "Одит на текущото състояние", p: "Проверяваме договорите, регистрациите и досиетата за пропуски и несъответствия с КТ." },
      { h: "Настройка на процеса", p: "Определяме график за подаване на данни за отработено време, отсъствия и бонуси." },
      { h: "Месечна обработка", p: "Изготвяме ведомостта, платежните към бюджета и подаваме Декларации 1 и 6 в срок." },
      { h: "Годишни задължения", p: "Служебни бележки, справки по чл. 73 от ЗДДФЛ и годишно преизчисляване на данъка." },
    ],
    faqs: [
      { q: "Колко струва обработката на заплати?", a: "Ориентировъчно от 12 € на служител месечно, в зависимост от броя персонал и сложността (сумирано време, нощен труд, командировки)." },
      { q: "Как се гарантира конфиденциалността на заплатите?", a: "Данните се обменят по защитени канали, достъп имат само определени специалисти, а фишовете се изпращат лично на всеки служител." },
      { q: "Обработвате ли граждански договори и хонорари?", a: "Да — изчисляваме възнаграждения по извънтрудови правоотношения, сметки за изплатени суми и служебни бележки." },
    ],
    related: ["abonament", "konsultacii", "registracia"],
  },
  {
    id: "registracia",
    slug: "registrirane-na-firmi",
    num: "05",
    title: "Регистриране на фирми",
    seoTitle: "Регистриране на фирма в Пловдив — ЕООД, ООД, ЕТ | RightAccount",
    description:
      "Регистрация на ЕООД, ООД и ЕТ в Търговския регистър за 2–4 работни дни: избор на правна форма, учредителни документи, ДДС регистрация и счетоводна настройка на новата фирма.",
    keywords: ["регистриране на фирми", "регистрация на ЕООД", "регистрация на ООД", "откриване на фирма Пловдив", "регистрация по ЗДДС"],
    intro:
      "От избора на правна форма до вписването в Търговския регистър — за дни, не за седмици. Стартирайте бизнеса си с коректно счетоводство от първия ден.",
    priceFrom: "от 150 € + държавни такси",
    timeline: "2–4 работни дни",
    forWhom: [
      "Стартиращи предприемачи, които откриват първата си фирма",
      "Свободни професии, преминаващи от физическо лице към ЕООД",
      "Чуждестранни граждани и дружества, стартиращи дейност в България",
      "Съществуващи фирми, откриващи дъщерно дружество или клон",
    ],
    includes: [
      { h: "Консултация за правна форма", p: "ЕООД, ООД, ЕТ или свободна професия — сравняваме данъчна тежест, отговорност и разходи за поддръжка." },
      { h: "Учредителни документи", p: "Учредителен акт/дружествен договор, протоколи, декларации, образец от подпис и съгласие на управителя." },
      { h: "Вписване в Търговския регистър", p: "Подаване на заявление А4 по електронен път с по-ниска държавна такса и проследяване до вписването." },
      { h: "Регистрация по ЗДДС", p: "Задължителна или доброволна регистрация по ДДС, включително при вътреобщностни сделки и OSS режим." },
      { h: "Банкова сметка и капитал", p: "Съдействие за набирателна сметка, внасяне на капитала и последващо откриване на разплащателна сметка." },
      { h: "Счетоводен старт", p: "Настройка на фактуриране, касов апарат/СУПТО, самоосигуряване на управителя и първи месечни задължения." },
    ],
    steps: [
      { h: "Избор на име и структура", p: "Проверяваме уникалността на името и определяме съдружници, капитал и управител." },
      { h: "Подготовка и подписване", p: "Изготвяме документите до 1 работен ден; подписвате пред нотариус само където е задължително." },
      { h: "Подаване и вписване", p: "Подаваме електронно в Агенцията по вписванията; вписването отнема обикновено 2–4 работни дни." },
      { h: "След регистрацията", p: "ДДС регистрация, самоосигуряване, печат и абонамент за счетоводство — ако желаете, без прекъсване." },
    ],
    faqs: [
      { q: "Колко струва регистрацията на ЕООД?", a: "Нашата такса стартира от 150 €, плюс държавна такса за електронно подаване, нотариална заверка и банкова такса за набирателна сметка." },
      { q: "Какъв минимален капитал е нужен?", a: "Минималният капитал за ЕООД/ООД е символичен (2 лв. равностойност), но препоръчваме реалистичен капитал според дейността." },
      { q: "Трябва ли да присъствам лично?", a: "Само за нотариалната заверка на образеца от подпис на управителя. Всичко останало се извършва дистанционно." },
    ],
    related: ["abonament", "konsultacii", "zaplati"],
  },
  {
    id: "konsultacii",
    slug: "danachni-i-trudovi-konsultacii",
    num: "06",
    title: "Данъчни и трудови консултации",
    seoTitle: "Данъчни консултации и трудови консултации | RightAccount Пловдив",
    description:
      "Консултации по данъчно, трудово и осигурително законодателство: законна данъчна оптимизация, ДДС, дивиденти, трудови договори, проверки от НАП и Инспекцията по труда.",
    keywords: ["данъчни консултации", "трудови консултации", "данъчна оптимизация", "консултация ДДС", "консултация трудов договор"],
    intro:
      "Ясни отговори защо плащате и къде отиват парите, които превеждате на държавата. Консултираме при стартиране, разширяване или законна оптимизация на данъци, заплати и осигуровки.",
    priceFrom: "от 40 € / час",
    timeline: "Среща до 2 работни дни",
    forWhom: [
      "Собственици, планиращи ново направление, инвестиция или разпределение на дивидент",
      "Фирми пред данъчна ревизия или проверка от Инспекцията по труда",
      "Работодатели с въпроси по трудови договори, графици, отпуски и прекратяване",
      "Физически лица с доходи от наем, чужбина, криптовалути или свободна професия",
    ],
    includes: [
      { h: "Данъчно планиране", p: "Законна оптимизация на корпоративен данък, дивиденти, разходи за автомобили и представителни цели." },
      { h: "ДДС консултации", p: "Регистрация, място на изпълнение, вътреобщностни доставки, OSS, обратно начисляване и данъчен кредит." },
      { h: "Трудово право за работодатели", p: "Трудови договори, работно време, дисциплинарни наказания, прекратяване и защита при спорове." },
      { h: "Осигурително законодателство", p: "Самоосигуряване, осигуряване на управители, пенсионери, чуждестранни лица и A1 удостоверения." },
      { h: "Представителство пред НАП и ИТ", p: "Подготовка за проверки, отговори на искания за документи и възражения срещу актове." },
      { h: "Писмени становища", p: "Аргументирани писмени становища с позоваване на нормативната база и практиката на НАП и съдилищата." },
    ],
    steps: [
      { h: "Описвате казуса", p: "По телефон, имейл или чрез формата — с наличните документи и въпросите си." },
      { h: "Анализ", p: "Проучваме нормативната база, указанията на НАП и съдебната практика по вашия въпрос." },
      { h: "Консултация", p: "Среща в офиса или онлайн с конкретни варианти, рискове и препоръка." },
      { h: "Изпълнение", p: "При желание — прилагаме решението и следим резултата в рамките на абонамента." },
    ],
    faqs: [
      { q: "Първата консултация безплатна ли е?", a: "Да — първата опознавателна консултация до 30 минути е безплатна. Специализирани становища се таксуват на час или на казус." },
      { q: "Консултирате ли физически лица?", a: "Да — за доходи от наем, продажба на имоти, доходи от чужбина, криптоактиви и годишна данъчна декларация по ЗДДФЛ." },
      { q: "Представлявате ли ни пред НАП при ревизия?", a: "Да — подготвяме документацията, участваме в срещите и изготвяме възражения и жалби срещу ревизионни актове." },
    ],
    related: ["abonament", "zaplati", "godishno"],
  },
];

export const SITE_URL = "https://rightaccountplovdiv.com";

export const getPages = (lang) => (lang === "en" ? SERVICE_PAGES_EN : SERVICE_PAGES);
export const getServicePage = (slug, lang = "bg") => getPages(lang).find((s) => s.slug === slug);
export const getServiceById = (id, lang = "bg") => getPages(lang).find((s) => s.id === id);
